import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { useFeaturePath } from '~/utils/hooks/useFeaturePath';
import { CreatorsListPage } from '~/features/creators-list/pages/creators-list';
import { creatorIdParamName, FEATURE_ROUTER_PATH, PROFILE_PATH } from '../config';
import * as DashboardFeature from '~/features/dashboard';
import { features } from '~/features';
import * as CreatorsListFeature from '~/features/creators-list';
import { DashboardPreview } from '~/features/dashboard/components/dashboard-preview';
import { DashboardSongPreview } from '~/features/dashboard/components/dashboard-song-preview';
import { ProfilePage } from '~/features/dashboard/pages/profile';

export const FeatureRouter = () => {
    const getPath = useFeaturePath(FEATURE_ROUTER_PATH);

    return (
        <Switch>
            <Route exact path={getPath()} component={CreatorsListPage} />
            <Route exact path={PROFILE_PATH} component={ProfilePage} />
            <Route exact path={getPath('/preview')} component={DashboardPreview} />
            <Route exact path={getPath('/song-preview')} component={DashboardSongPreview} />
            <Route path={getPath(`/:${creatorIdParamName}${DashboardFeature.FEATURE_ROUTER_PATH}`)} component={DashboardFeature.FeatureRouter} />
            <Redirect to={features[CreatorsListFeature.name].FEATURE_ROUTER_PATH} />
        </Switch>
    );
};
